class CountdownTimer {
  constructor(durationInMinutes = 10) {
    this.countDownDate = new Date(new Date().getTime() + 1000 * 60 * durationInMinutes);
    this.timerInterval = null;
  }

  static twoDigit(number) {
    return `${number > 9 ? "" : "0"}${number}`;
  }

  start() {
    this.timerInterval = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date().getTime();
    const distance = this.countDownDate - now;
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const countdownElements = document.querySelectorAll('[data-countdown-timer]');
    if (countdownElements.length) {
      for (const item of countdownElements) {
        if (distance <= 0) {
          this.handleTimerEnd(item);
          return;
        }
        item.innerHTML = `${minutes}:${CountdownTimer.twoDigit(seconds)}`;
      }
    }
  }

  handleTimerEnd(element) {
    element.innerHTML = '0:00';
    clearInterval(this.timerInterval);
    // document.location.href = '/cart/clear';
  }
}

// Usage
const timer = new CountdownTimer();
timer.start();
